var DEFAULT_SELECTION = '-Please select-';
var BPMergersController = (function () {
    function BPMergersController(settings, env, $compile, $filter, socket, $scope, Dialog, notify, DTOptionsBuilder, DTColumnBuilder) {
        var _this = this;
        this.settings = settings;
        this.env = env;
        this.$compile = $compile;
        this.$filter = $filter;
        this.socket = socket;
        this.$scope = $scope;
        this.Dialog = Dialog;
        this.notify = notify;
        this.DTOptionsBuilder = DTOptionsBuilder;
        this.DTColumnBuilder = DTColumnBuilder;
        this.processing = false;
        this.bpMergersDataLoaded = false;
        this.importingExcel = false;
        this.TEMPLATE_CONFIRM = 'confirm-prompt.html';
        this.exportFired = false;
        this.tableItems = [];
        this.historyTable = {};
        this.docTable = [];
        this.backendModuleName = 'admin/bpMergers/index';
        this.scopePrefix = 'admin.bpMergers';
        this.scopeGetLogs = this.scopePrefix + ".getLogs";
        this.scopeDeleteRecord = this.scopePrefix + ".delete";
        this.scopeUpdateRecord = this.scopePrefix + ".update";
        this.scopeCreateRecord = this.scopePrefix + ".insert";
        this.scopeExport = this.scopePrefix + ".export";
        this.table = {
            dtColumns: {},
            dtInstance: {},
            search: '',
            select_options: {},
            visible: 0
        };
        this.historyTable = {
            instance: {}
        };
        this.historyTable.options = this.DTOptionsBuilder
            .newOptions()
            .withIBMTheme()
            .withOption('stateSave', true)
            .withOption('ordering', false)
            .withOption('searchDelay', 350)
            .withOption('alphabetColumnIndex', 2);
        this.historyTable.columnDefs = [];
        // CREATE
        this.socket.forward(this.scopeCreateRecord, this.$scope);
        this.$scope.$on("socket:" + this.scopeCreateRecord, function (event, data) {
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Creating BP Mergers record');
                _this.notify.error("Unable to create a BP Mergers record");
            }
            else {
                _this.notify.success('BP Mergers record successfuly added');
                _this.getHistory();
            }
            _this.table.dtInstance.DataTable.ajax.reload(null, true);
        });
        // DELETE
        this.socket.forward(this.scopeDeleteRecord, this.$scope);
        this.$scope.$on("socket:" + this.scopeDeleteRecord, function (event, data) {
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Deleting BP Mergers record');
                _this.notify.error("Unable to delete BP Mergers record");
            }
            else {
                _this.notify.success('BP Mergers record was deleted successful');
                _this.getHistory();
            }
            _this.table.dtInstance.DataTable.ajax.reload(null, true);
        });
        // UPDATE
        this.socket.forward(this.scopeUpdateRecord, this.$scope);
        this.$scope.$on("socket:" + this.scopeUpdateRecord, function (event, data) {
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Updating BP Mergers record');
                _this.notify.error("Unable to update BP Mergers record");
            }
            else {
                _this.notify.success('BP Mergers record successfuly updated');
                _this.getHistory();
            }
            _this.table.dtInstance.DataTable.ajax.reload(null, true);
        });
        //GET HISTORY
        this.socket.forward(this.scopeGetLogs, this.$scope);
        this.$scope.$on("socket:" + this.scopeGetLogs, function (event, data) {
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Loading BP Mergers log records');
                _this.notify.error("Unable to extract BP Mergers log records");
            }
            else {
                if (data) {
                    _this.docTable = data.reverse();
                }
            }
            _this.table.dtInstance.DataTable.ajax.reload(null, true);
        });
        // DOWNLOAD EXCEL
        this.socket.forward(this.scopeExport, this.$scope);
        this.$scope.$on("socket:" + this.scopeExport, function (event, data) {
            _this.exportFired = false;
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Exporting list');
                return _this.notify.error("Can't to export list");
            }
            else {
                _this.downloadFile(data, 'DMT-BP-Mergers');
                _this.notify.success('BP Mergers was exported successful');
                _this.getHistory();
            }
        });
    }
    /**
     * Function to delete a row in DB
     */
    BPMergersController.prototype.deleteRow = function (event, rowId) {
        var _this = this;
        var idx = this.tableItems[rowId].ID;
        var removableClient = {};
        this.Dialog.confirmDelete(event, idx).then(function (dResult) {
            if (dResult) {
                removableClient = _this.getClientById(idx);
                var deletedData = {
                    id: removableClient.ID
                };
                _this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        data: deletedData,
                        email: _this.env.user.email,
                        function: 'deleteRecord',
                        scopeBack: _this.scopeDeleteRecord,
                        script: _this.backendModuleName,
                        token: _this.env.user.token
                    }
                });
            }
        });
    };
    /**
     * Function to insert a row in DB
     */
    BPMergersController.prototype.createRecord = function (event) {
        var _this = this;
        var item = {
            bpMergers: {
                bpCountry: '-Please select-',
                bpLosingCEID: '',
                bpLosingName: '',
                bpWinningCEID: '',
                bpWinningName: ''
            },
            icon: 'QUESTION',
            label: 'Add record to existing list',
            listCountries: this.extractCountry(),
            message: 'Are you sure, you want to add a new record to existing list?'
        };
        this.Dialog.updateValidForm(event, item, this.TEMPLATE_CONFIRM)
            .then(function (dResult) {
            if (dResult.confirm) {
                _this.Dialog.updateValidForm(event, item, 'bpmergers-create.html')
                    .then(function (answer) {
                    item.bpMergers = answer.bpMergers;
                    item.bpMergers.longBPCountryName = item.bpMergers.bpCountry;
                    item.bpMergers.bpCountry = _this.takeShortCountry(item.bpMergers.bpCountry);
                    _this.socket.emit('module', {
                        module: {
                            application: 'dmt',
                            data: item.bpMergers,
                            email: _this.env.user.email,
                            function: 'insertNewRecord',
                            scopeBack: _this.scopeCreateRecord,
                            script: _this.backendModuleName,
                            token: _this.env.user.token
                        }
                    });
                });
            }
        });
        return;
    };
    /**
     * Function to update a row in DB
     */
    BPMergersController.prototype.editClient = function (event, rowId) {
        var _this = this;
        var idx = this.tableItems[rowId].ID;
        var editableClient = this.getClientById(idx);
        var tit = 'Update BP Mergers record';
        var updatedData = {
            content: {
                bpCountry: editableClient.BP_COUNTRY,
                id: editableClient.ID,
                losingBPCeid: editableClient.LOSING_BP_CEID,
                losingBPName: editableClient.LOSING_BP_NAME,
                winningBPCeid: editableClient.WINNING_BP_CEID,
                winningBPName: editableClient.WINNING_BP_NAME
            },
            label: tit,
            listCountries: this.extractCountry()
        };
        this.Dialog.updateValidForm(event, updatedData, 'bpmergers-edit.html')
            .then(function (dResult) {
            var dataForUpdate = updatedData.content;
            dataForUpdate.longBPCountryName = updatedData.content.bpCountry;
            dataForUpdate.bpCountry = _this.takeShortCountry(updatedData.content.bpCountry);
            var originalDataUpdate = {
                bpCountry: _this.takeShortCountry(editableClient.BP_COUNTRY),
                id: editableClient.ID,
                longBPCountryName: editableClient.BP_COUNTRY,
                losingBPCeid: editableClient.LOSING_BP_CEID,
                losingBPName: editableClient.LOSING_BP_NAME,
                winningBPCeid: editableClient.WINNING_BP_CEID,
                winningBPName: editableClient.WINNING_BP_NAME
            };
            _this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    data: dataForUpdate,
                    email: _this.env.user.email,
                    function: 'updateRecord',
                    originalData: originalDataUpdate,
                    scopeBack: _this.scopeUpdateRecord,
                    script: _this.backendModuleName,
                    token: _this.env.user.token
                }
            });
        });
    };
    /**
     * Function to prepare the DB info for export
     */
    BPMergersController.prototype.exportBPMergers = function () {
        this.exportFired = true;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: {},
                email: this.env.user.email,
                function: 'exportToExcel',
                scopeBack: this.scopeExport,
                script: this.backendModuleName,
                token: this.env.user.token
            }
        });
    };
    BPMergersController.prototype.$onInit = function () {
        var _this = this;
        this.table.dtColumns = this.buildColumns();
        this.table.dtOptions = this.DTOptionsBuilder.newOptions()
            .withIBMTheme()
            .withOption('alphabetColumnIndex', 1)
            .withOption('ajax', this.buildAjaxOption())
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('order', [[1, 'asc']]) // Default sorting by 2nd column
            .withPaginationType('full_numbers')
            .withOption('createdRow', function (row) {
            _this.$compile(angular.element(row).contents())(_this.$scope);
        })
            .withOption('drawCallback', function (settings) {
            _this.processing = false;
        });
        this.getHistory();
    };
    BPMergersController.prototype.buildAjaxOption = function () {
        var _this = this;
        return {
            beforeSend: function (request) {
                _this.processing = true;
                _this.bpMergersDataLoaded = false;
                request.setRequestHeader('Authorization', "Bearer " + _this.env.user.token);
            },
            data: function (draw) {
                var dt = _this.table.dtInstance.DataTable;
                if (dt && dt.context && Array.isArray(dt.context)) {
                    draw.alphabetSearch = dt.context[0].alphabetSearch;
                }
            },
            dataSrc: function (data) {
                _this.bpMergersDataLoaded = true;
                _this.tableItems = data.data;
                _this.processing = false;
                return data.data;
            },
            error: function (xhr, errorMessage, thrown) {
                var items = {
                    icon: 'ERROR',
                    message: 'Unable to retrieve BP Mergers data from the server for the following reason:<br><br> ',
                    title: 'Server Error'
                };
                if (xhr.responseText) {
                    items.message += "<b>" + xhr.responseText + "</b>\n                    <br>Please try again, if the problem persists contact the DMT System Administrators";
                }
                else {
                    if (errorMessage === 'timeout' || thrown.toLowerCase().indexOf('time-out') > -1) {
                        items.message += '<b>The server took too long to send the data and timed-out -&nbsp;</b><br>';
                    }
                    items.message += "<b style=\"color:red\">" + errorMessage + "/" + thrown + "</b><br><br>\n                    This is usually a temporary problem.\n                    &nbsp;Please try again, if the problem persists contact the DMT System Administrators";
                }
                _this.bpMergersDataLoaded = true;
                _this.importingExcel = false;
                $('#table_processing').hide();
            },
            type: 'POST',
            url: '/api/admin/bp-mergers'
        };
    };
    BPMergersController.prototype.buildColumns = function () {
        return [
            this.DTColumnBuilder.newColumn('BP_COUNTRY').notSortable()
                .withOption('name', 'BP_COUNTRY').withTitle('BP Country'),
            this.DTColumnBuilder.newColumn('LOSING_BP_CEID').notSortable()
                .withOption('name', 'LOSING_BP_CEID').withTitle('Losing BP CEID'),
            this.DTColumnBuilder.newColumn('LOSING_BP_NAME').notSortable()
                .withOption('name', 'LOSING_BP_NAME').withTitle('Losing BP Name'),
            this.DTColumnBuilder.newColumn('WINNING_BP_CEID').notSortable()
                .withOption('name', 'WINNING_BP_CEID').withTitle('Winning BP CEID'),
            this.DTColumnBuilder.newColumn('WINNING_BP_NAME').notSortable()
                .withOption('name', 'WINNING_BP_NAME').withTitle('Winning BP Name'),
            this.DTColumnBuilder.newColumn('actions').notSortable()
                .withOption('name', 'actions').withTitle('Actions').renderWith(this.actionButtons)
        ];
    };
    BPMergersController.prototype.actionButtons = function (data, type, full, meta) {
        return "<md-button class=\"edit-button md-button md-ink-ripple\" ng-click=\"vm.editClient($event, '" + meta.row + "')\"\n            ng-disabled=\"vm.isSaving\" aria-label=\"Edit\">\n                <md-icon class=\"black_icon\" md-svg-icon='edit_pen'></md-icon>\n        </md-button>\n\n        <md-button class=\"delete-button md-button md-ink-ripple\" ng-click=\"vm.deleteRow($event, '" + meta.row + "')\"\n            ng-disabled=\"vm.isSaving\" aria-label=\"Delete\">\n                <md-icon md-svg-icon='delete'></md-icon>\n        </md-button>";
    };
    /**
     * Function to get all history from Cloudant
     */
    BPMergersController.prototype.getHistory = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                email: this.env.user.email,
                function: 'getBPMergersLogsData',
                scopeBack: this.scopeGetLogs,
                script: this.backendModuleName,
                token: this.env.user.token
            }
        });
    };
    /**
     * Function to download files
     */
    BPMergersController.prototype.downloadFile = function (file, name) {
        var a = document.createElement('A');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none;');
        var url = window.URL.createObjectURL(new Blob([file], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }));
        a.setAttribute('href', url);
        var d = new Date().toDateString();
        a.setAttribute('download', name + " " + d + ".xlsx");
        a.click();
    };
    BPMergersController.prototype.getClientById = function (id) {
        return this.tableItems.find(function (item) { return item['ID'] === id; });
    };
    /**
     * Function to extract country
     */
    BPMergersController.prototype.extractCountry = function () {
        return this.settings.country_list.map(function (el) { return el.country; });
    };
    BPMergersController.prototype.takeShortCountry = function (longCountryName) {
        return _.find(this.settings.country_list, ['country', longCountryName]).short;
    };
    /**
     * Function to handle all errors
     */
    BPMergersController.prototype.isIncomingErrors = function (data) {
        return data && data.error;
    };
    /**
     * Function to show all errors
     */
    BPMergersController.prototype.handleIncomingErrors = function (data, name) {
        data.error = data.message;
        var allErrorsInfo = {
            allErrors: {
                errors: [data]
            },
            windowName: name
        };
        this.Dialog.showingErrors(event, allErrorsInfo, 'showing-errors.html').then(function (dResult) {
            if (dResult) {
                return;
            }
        });
        return;
    };
    // tslint:disable-next-line:typedef
    BPMergersController.prototype.openActionMenu = function ($mdOpenMenu, event) {
        $mdOpenMenu(event);
    };
    BPMergersController.$inject = [
        'settings',
        'env',
        '$compile',
        '$filter',
        'socket',
        '$scope',
        'Dialog',
        'notify',
        'DTOptionsBuilder',
        'DTColumnBuilder',
        'DTColumnDefBuilder'
    ];
    return BPMergersController;
}());
var BPMergersComponent = (function () {
    function BPMergersComponent() {
        this.templateUrl = 'bpmergers-view.html';
        this.controllerAs = 'vm';
        this.controller = BPMergersController;
    }
    return BPMergersComponent;
}());
angular
    .module('application')
    .component('viewBpmergersSection', new BPMergersComponent());

//# sourceMappingURL=bpmergers.view.component.js.map
